import * as t from 'io-ts';

import {makeApiType} from './apiTypes';
import {parseDataGroupFromConversation, RDataGroup} from './dataGroupModel';

/*
 * Runtime type.
 */

const RConversationBatch = t.readonly(
  t.type({
    dataGroups: t.readonlyArray(RDataGroup),
  }),
);

/*
 * Type.
 */

export interface ConversationBatchModel extends t.TypeOf<typeof RConversationBatch> {}

/*
 * IO methods.
 */

function parseConversationBatch(src: any): ConversationBatchModel {
  return {
    dataGroups: src.conversations && src.conversations.map(parseDataGroupFromConversation),
  };
}

/*
 * API type.
 */

export const ApiConversationBatch = makeApiType(
  'conversationBatch',
  RConversationBatch,
  parseConversationBatch,
);
